// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
var __webpack_exports__ = __webpack_require__.O(undefined, ["vendors-node_modules_reduxjs_toolkit_dist_redux-toolkit_esm_js-node_modules_classnames_index_-ea675a"], () => (__webpack_require__("./src/index.jsx")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
